export const formatTopicId = (key: string) => {
  const sanitizedKey = key.replace(/\\/g, '-'); // Replace all backslashes with dashes
  return `@${sanitizedKey}`;
};

export const formatTopicPath = (path: string) => {
  return `/topic/${path}`;
};
